$(window).on('load resize orientationchange', function (DEBUG) {
  $('.js-border-accent-ttl').each(function () {
    var target = $(this),
        padding = Number(target.find('.c-border-accent-ttl-sub').innerWidth()) + 40;
    target.css('padding-left', padding + 'px');
  });
});